import React, { useState } from "react";
import dayjs from "dayjs";
import OffcanvasFooter from "../../../../Helpers/Offcanvasfooter/OffcanvasFooter";
import { Input } from "../../../../Helpers/Input/Input";
import RadioButton from "../../../../Helpers/RadioButton/RadioButton";

const options = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Severe", value: "severe" },
];

const FormBody = ({ start, end }) => {
  let startDate;
  let endDate;
  const [value, setValue] = useState(1);

  if (start) {
    startDate = dayjs(start).format("DD-MM-YYYY");
  }
  if (end) {
    endDate = dayjs(end).format("DD-MM-YYYY");
  }

  return (
    <>
      <form className="h-form">
        <div className="userinfo mb-24">
          <div className="flex flex-row gap-16 w-100 mb-16">
            <Input
              title="Vehicle"
              type="text"
              placeholder="Ex. Volvo"
              formstyle="user-form w-100 flex-1"
              id="vehicle"
              name="vehicle"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.name}
              //   touched={addData.touched.name}
              //   value={addData.values.name || ""}
            />
            <Input
              title="Maintenance type"
              type="text"
              placeholder="Ex. Regular"
              formstyle="user-form w-100 flex-1"
              id="maintenance_type"
              name="maintenance_type"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.email}
              //   touched={addData.touched.email}
              //   value={addData.values.email || ""}
            />
          </div>

          <div className="flex flex-row gap-16 w-100 mb-16">
            <Input
              title="Workshop"
              type="text"
              placeholder="Ex. Workshop 1"
              formstyle="user-form w-100 flex-1"
              id="workshop"
              name="workshop"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.password}
              //   touched={addData.touched.password}
              //   value={addData.values.password || ""}
            />
            <Input
              title="Start Date"
              type="text"
              placeholder="Ex. 11/10/2024"
              formstyle="user-form w-100 flex-1"
              id="startDate"
              name="startDate"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.password}
              //   touched={addData.touched.password}
              value={startDate ? startDate : ""}
            />
          </div>
          <div className="flex flex-row gap-16 w-100 mb-16">
            <Input
              title="Estimation Date"
              type="text"
              placeholder="Ex. 11/10/2024"
              formstyle="user-form w-100 flex-1"
              id="endDate"
              name="endDate"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.password}
              //   touched={addData.touched.password}
              value={endDate ? endDate : ""}
            />
            <Input
              title="Description"
              type="text"
              placeholder="Description about"
              formstyle="user-form w-100 flex-1"
              id="description"
              name="description"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.password}
              //   touched={addData.touched.password}
              //   value={addData.values.password || ""}
            />
          </div>
          <RadioButton
            title={"Priority"}
            formstyle="user-form w-100 flex-1"
            options={options}
            value={value}
            setValue={setValue}
          />
        </div>
        <OffcanvasFooter />
      </form>
    </>
  );
};

export default FormBody;
